import React from 'react'
import { withRouter } from 'react-router-dom'

import './PageMenu.css'
import PageHeader from '../PageHeader/PageHeader'

function PageMenu({ icon, children, menuItems, history }) {
  return (
    <div className="PageMenu">
      <PageHeader icon={icon}>{children}</PageHeader>
      <ul>
        {menuItems.map(item => (
          <li
            key={item.menu}
            onClick={() => {
              if (!item.command) {
                history.push(item.path)
              } else {
                item.command()
              }
            }}
          >
            {item.menu}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default withRouter(PageMenu)
